import React from "react"

export default function GitHub(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 195 195" {...props}>
      <g fill="none" fillRule="nonzero">
        <path fill="#12100E" d="M0 0h195v195H0z" />
        <path
          fill="#FFF"
          d="M46.5 65.2A5 5 0 0045 61L32.7 46.2V44h38l29.3 64.4L125.8 44H162v2.2l-10.5 10a3 3 0 00-1.1 3v73.6a3 3 0 001.1 3l10.3 10v2.2h-51.4v-2.2l10.6-10.3c1-1 1-1.3 1-3V73l-29.4 74.8h-4L54.4 73v50.1a7 7 0 001.9 5.8L70 145.6v2.2H31v-2.2l13.8-16.7a6.7 6.7 0 001.7-5.8V65.2z"
        />
      </g>
    </svg>
  )
}
